<template>
  <el-container style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">

      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valueff" @change="fenzu()"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optionff"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="Tname"   filterable placeholder="请选择" >
              <el-option
                v-for="item in Tnames"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          添加图片:<el-input v-model="addImage" style="width: 150px;" placeholder="请输入图片名称"></el-input>
          <el-button type="success" round @click="addImageCheck()">添加</el-button>
      </el-row>
      <el-row style="margin-top: 30px;">

        <div v-for="(item,indexs) in imageList" :key="indexs" style="float: left;">
          <img width="100%"  :src="item.img" alt="" style="width: 100px;height: 100px;">
          <i class="el-icon-delete" @click="delImage(indexs)" style="margin-left: 10px;"></i>
        </div>

      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="num" style="width: 210px;" placeholder="请输入数量如(2-10)"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          名称:<el-input v-model="shuoming" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          时间尺:<el-input v-model="timej" style="width: 150px;" placeholder="请输入时间间隔范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          速率尺:<el-input v-model="su" style="width: 150px;" placeholder="请输入速率范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          透视尺:<el-input v-model="tou" style="width: 150px;" placeholder="请输入透视"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          缩放尺:<el-input v-model="bi" style="width: 150px;" placeholder="请输入比例"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="sx"  filterable placeholder="请选择" >
              <el-option
                v-for="item in sxs"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valueg"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optiong"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
           <el-select v-model="effect" multiple placeholder="请选择效果">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
           <el-select v-model="flys" multiple placeholder="请选择效果">
              <el-option
                v-for="item in optionf"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
           <el-select v-model="fengx" multiple placeholder="请选择风向">
              <el-option
                v-for="item in optionfx"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
         <el-col :span="3" >

           <el-time-select
             style="margin-bottom: -1px;margin-right: -21px;"
             v-model="time1"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择开始时间">
           </el-time-select>
         </el-col>
         <el-col :span="3">
           <el-time-select
             v-model="time2"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择结束时间">
           </el-time-select>
         </el-col>
         <el-col :span="2" style="text-align: center;">
           <el-input v-model="at" style="width: 150px;" placeholder="请输入百分比"></el-input>
         </el-col>
         <el-col :span="1" style="text-align: center;">
           <el-button type="primary" style="background-color: #409eff;" @click="addTime()" round>添加时段</el-button>
         </el-col>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="times"
            height="300"
          	border
          	style="width: 25%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="time"
              width="200"
          	  label="时段"
          	   >

          	</el-table-column>
          	<el-table-column
              prop="bai"
              width="150"
          	  label="百分比"
          	   >
          	</el-table-column>

            <el-table-column
              width="180"
              label="操作"
               >
               <template slot-scope="scope">
                 <i class="el-icon-delete" @click="delTime(scope.$index)"></i>
               </template>
            </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          <el-button round :class="{'pai':pait==1}" @click="pai(1)">开关排序</el-button>
          <el-button round :class="{'pai':pait==2}" @click="pai(2)">时间排序</el-button>
      </el-row>
    </el-row>
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        height="1500"
      	border
      	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
        <el-table-column

          width="100"
          label="开关"
           >
           <template slot-scope="scope">
                <div style="color: greenyellow;"  @click="kg(2,scope.row.id)" v-if="scope.row.status == 1">开</div>
                <div style="color: red;"  @click="kg(1,scope.row.id)" v-if="scope.row.status == 2">关</div>
                <div style="color: blue;margin-top: 20px;"  @click="changeT(11,scope.row.bsc,scope.row.id)" >{{scope.row.bsc}}</div>
                <div style="color: blue;margin-top: 20px;"  @click="changeT(10,scope.row.tlc,scope.row.id)" >{{scope.row.tlc}}</div>

           </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="复制"

           >
            <template slot-scope="scope">
                <div  @click="copy(2,scope.row.id)" style="color: #409eff;margin-top: 20px;">(复制)</div>

            </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="名称"

           >
            <template slot-scope="scope">
                <div  @click="changeT(17,scope.row.shuoming,scope.row.id)" >{{scope.row.shuoming}}</div>

            </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="T"
           >
           <template slot-scope="scope">
               <div  @click="changeT(16,scope.row.tname,scope.row.id)">{{scope.row.tname}}</div>



           </template>
        </el-table-column>
      	<!-- <el-table-column

          width="750"
      	  label="图片"
      	   >
           <template slot-scope="scope">
             <div v-for="(items,indexs) in scope.row.img" :key="indexs" style="float: left;margin-right: 20px;">


               <div style="float: left;">
                  <el-button type="info" round @click="imageNewChange(items.id,items.name)">{{items.name}}</el-button>
                  <i class="el-icon-circle-close" style="position: absolute;margin-left: 10px;margin-top: 15px;" @click="del(items.id)"></i>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(1,items.dis,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">{{items.dis}}</p>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(2,items.w,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">w:{{items.w}}</p>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(3,items.h,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">h:{{items.h}}</p>
               </div>
             </div>
             <el-button type="success" round @click="addNewImage(scope.row.id)">添加图片</el-button>

           </template>
      	</el-table-column> -->
        <el-table-column

          width="750"
          label="图片"
           >
           <template slot-scope="scope">
             <el-tooltip class="item" effect="dark" :content="scope.row.imggname" placement="right">
             <div style="float: left;margin-right: 20px;margin-top: 10px;color: blue;" @click="seeImage(scope.row.id)">
                查看图片分组
             </div>
             </el-tooltip>


             <el-button type="success" round @click="addNewImage(scope.row.id)">添加图片</el-button>
             <el-button type="success" round @click="addNewImages(scope.row.id)">添加组图</el-button>
           </template>
        </el-table-column>
        <el-table-column

          width="200"
          label="时间段"
           >
           <template slot-scope="scope">
             <div style="color: blue;margin-bottom: 20px;"  @click="changeT(12,scope.row.zyc,scope.row.id)" >{{scope.row.zyc}}</div>
             <div  v-for="(items,indexs) in scope.row.time" :key="indexs" @click="ct(items.id,items.time,items.bai)">
               <div style="float: left;">{{items.time}} </div>
               <div style="float: left;">#{{items.bai}} </div>
               <div style="float: left;"><i class="el-icon-circle-close" style="margin-left: 10px;" @click="delEc(items.id)"></i></div>
             </div>
             <i v-if="scope.row.time.length == 0" style="margin-left: 30px;" @click="changeTime(scope.row.id)" class="el-icon-plus el-icon-circle-plus-outline"></i>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="透视"
           >
           <template slot-scope="scope">
               <div  @click="changeT(9,scope.row.tou,scope.row.id)">{{scope.row.tou}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="方向"

           >
           <template slot-scope="scope">
               <div  @click="changeT(15,scope.row.fengx,scope.row.id)">{{scope.row.fengx}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="分组"

           >
           <template slot-scope="scope">
               <div  @click="changeT(5,scope.row.zu,scope.row.id)">{{scope.row.zu}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="比例"

           >
           <template slot-scope="scope">
               <div  @click="changeT(7,scope.row.bi,scope.row.id)">{{scope.row.bi}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="星空粒子"

           >
           <template slot-scope="scope">
               <div  @click="changeT(8,scope.row.sx,scope.row.id)">{{scope.row.sx}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="数量"
           >
           <template slot-scope="scope">
               <div  @click="changeT(1,scope.row.num,scope.row.id)">{{scope.row.num}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="200"
          label="效果"
           >
           <template slot-scope="scope">
               <div  @click="changeT(13,scope.row.effect,scope.row.id)">{{scope.row.effect}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="150"
          label="形态"
           >
           <template slot-scope="scope">
               <div  @click="changeT(14,scope.row.fly,scope.row.id)">{{scope.row.fly}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="轨迹"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.gui"  @click="changeT(2,scope.row.gui,scope.row.id)">{{scope.row.gui}}</div>
               <div v-else  @click="changeT(2,scope.row.gui,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="时间间隔范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.timea"  @click="changeT(3,scope.row.timea,scope.row.id)">{{scope.row.timea}}</div>
               <div v-else  @click="changeT(3,scope.row.timea,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="速率范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.su"  @click="changeT(4,scope.row.su,scope.row.id)">{{scope.row.su}}</div>
               <div v-else  @click="changeT(4,scope.row.su,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="操作"
           >
           <template slot-scope="scope">
             <i class="el-icon-delete" @click="delAll(scope.row.id)"></i>
           </template>






        </el-table-column>
        </el-table>
      </template>
      <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="20"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="修改时间段"
      :visible.sync="ctDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="ct_time"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="ctDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doCt()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加"
      :visible.sync="timeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="timesadd"/>
      <span slot="footer" class="dialog-footer">
    	<el-button style="margin-top: 10px;" @click="timeVisible = false">取 消</el-button>
    	<el-button style="margin-top: 10px;" type="primary" @click="doEc()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleds"
      width="30%"
      >
      <span>确认删除整组图片？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibleds = false">取 消</el-button>
    	<el-button type="primary" @click="doDells()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="高度尺"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片"
      :visible.sync="imgVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImg()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片组"
      :visible.sync="imgVisibleG"
      width="30%"
      center>
      <input type="text" class="searchTG" v-model="imgNameG"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisibleG = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImgG()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改图片"
      :visible.sync="imgVisiblec"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgNamec"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblec = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeImg()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看图片"
      :visible.sync="seeimgVisiblec"
      width="50%"
      center>
      <el-row  style="margin-top: 30px;" v-for="(items,indexs) in seeimgs">
          <div style="text-align: center;float: left;">
            {{items.name}}
          </div>
        <div style="text-align: center;float: left;color: red;margin-left: 20px;" @click="dels(items.value[0].id)">
          组删除
        </div>
          <div  style="text-align: center;float: left;margin-left: 30px;" v-for="(item,index) in items.value">
            <div>
              {{item.name}}
              <i class="el-icon-circle-close" style="position: absolute;margin-left: 5px;" @click="del(item.id)"></i>
            </div>
          </div>
      </el-row>
      </span>
    </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {

         page:1,
         count:0,
         dialogImageUrl: '',
         dialogVisible: false,
         tableData:[],
         imageList:[],
         options:[{'name':'呼吸','id':'(呼吸)'},{'name':'气球','id':'(气球)'},{'name':'等比','id':'(等比)'},{'name':'东','id':'(东)'},{'name':'南','id':'(南)'},{'name':'西','id':'(西)'},{'name':'北','id':'(北)'},
                  {'name':'东南','id':'(东南)'},{'name':'东北','id':'(东北)'},{'name':'西南','id':'(西南)'},{'name':'西北','id':'(西北)'}],
         optionf:[{'name':'完全随机','id':'(完全随机)'},{'name':'圆形等距','id':'(圆形等距)'},{'name':'圆形随机','id':'(圆形随机)'},{'name':'矩形等距','id':'(矩形等距)'},{'name':'矩形随机','id':'(矩形随机)'},
                  {'name':'三角等距','id':'(三角等距)'},{'name':'三角随机','id':'(三角随机)'},{'name':'直线等距','id':'(直线等距)'},{'name':'直线随机','id':'(直线随机)'},{'name':'S线等距','id':'(S线等距)'},
                  {'name':'S线随机','id':'(S线随机)'},{'name':'全屏等距','id':'全屏等距'},{'name':'全屏随机','id':'全屏随机'}],
         flys:['(完全随机)'],
         optionfx:[{'name':'东','id':'东'},{'name':'南','id':'南'},{'name':'西','id':'西'},{'name':'北','id':'北'},
                    {'name':'东南','id':'东南'},{'name':'西南','id':'西南'},{'name':'东北','id':'东北'},{'name':'西北','id':'西北'}],
         num:'',
         effect:'',
         dialogVisibled:false,
         delId:0,
         effect:[],
         centerDialogVisible:false,
         changes:'',
         c_id:0,
         time1:'',
         time2:'',
         at:100,
         times:[],
         timeStr:'',
         timeVisible:false,
         timec1:'',
         timec2:'',
         atc:100,
         timesc:[],
         timeStrc:'',
         ec_id:0,
         optiong:[{'name':'直线','value':'直线'},{'name':'弧线','value':'弧线'}],
         valueg:'直线',
         su:'0-0',
         timej:'0-0',
         t:1,
         ct_id:0,
         ct_time:'',
         ctDialogVisible:false,
         optionff:[{'name':'不分组','value':'不分组'},{'name':'组1','value':'组1'},{'name':'组2','value':'组2'},{'name':'组3','value':'组3'},{'name':'组4','value':'组4'},{'name':'组5','value':'组5'},{'name':'组6','value':'组6'},{'name':'组7','value':'组7'},{'name':'组8','value':'组8'},{'name':'组9','value':'组9'},{'name':'组10','value':'组10'}],
         valueff:'不分组',
         bi:'100',
         sx:'上',
         sxs:[{'name':'上','value':'上'},{'name':'下','value':'下'}],
         disDialogVisible:false,
         changeDis:'',
         disId:0,
         disName:'',
         tou:'100',
         addImage:'',
         imgVisible:false,
         imgName:'',
         imgId:0,
         imgVisiblec:false,
         imgNamec:'',
         imgIdc:0,
         tlc:'否',
         bsc:'100',
         zyc:'否',
         dist:0,
         seachName:'',
         timesadd:'',
         pait:1,
         seeimgVisiblec:false,
         seeimgs:[],
         imgVisibleG:false,
         imgNameG:'',
         dialogVisibleds:false,
         fengx:'风向',
         Tnames:[{'name':'T1','value':'T1'},{'name':'T2','value':'T2'},{'name':'T1+T2','value':'T1+T2'}],
         Tname:'T1+T2',
         shuoming:'未定义名称'

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImage(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementfxListSee'
      })
      .then(res=>{
        this.seeimgVisiblec = true;
      	this.seeimgs = res.data.list;

      })
      .catch(err=>{

      });
    },
    pai(t){
      this.pait = t;
      this.p = 1;
      this.loadData();
    },
    seach(){
      this.loadData();
    },
    imageNewChange(id,name){
      this.imgIdc = id;
      this.imgNamec = name;
      this.imgVisiblec = true;
    },
    doChangeImg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgNamec,
          id:this.imgIdc,
          t:3

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveChangeNew'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();
            this.imgVisiblec = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    doAddImg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgName,
          id:this.imgId,
          t:3

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMoreNew'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisible = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    doAddImgG(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgNameG,
          id:this.imgId,
          t:3

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMoreNewg'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisibleG = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    addNewImage(id){
      this.imgId = id;
      this.imgVisible = true;
    },
    addNewImages(id){
      this.imgId = id;
      this.imgVisibleG = true;
    },
    delImage(index){
      this.imageList.splice(index,1);
    },
    addImageCheck(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.addImage,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/addImageCheck'
      })
      .then(res=>{
         if(res.data.code == 200){

            this.imageList.push({'img':res.data.data.img,'gname':res.data.data.gname,'name':res.data.data.name,'size':res.data.data.size,'w':res.data.data.w,'h':res.data.data.h,'chi':res.data.data.chi,'url':res.data.data.url,'zhiling':res.data.data.zhiling})
         }else{
           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    copy(t,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          t:t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonCopy'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '复制成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    kg(p,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          p:p,
          t:2
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/statusChange'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    UploadUrl(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMore?t=3&id="+id
    },
    UploadUrls(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveChange?t=3&id="+id
    },
    handleAvatarSuccessch(res, file) {
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    handleAvatarSuccessdis(res, file) {
      this.clearFiles()
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    dischange(t,name,id){
      this.dist = t
      this.disId = id
      this.disName = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          t:3,
          dist:this.dist,
          name:this.disName,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementDisChange'
      })
      .then(res=>{
         this.disDialogVisible = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    fenzu(){
      if(this.valueff!='不分组'){
        this.tableData.forEach(item =>{
          if(item.zu == this.valueff){
            this.num = item.num
            this.timej = item.timea
            this.su = item.su
            this.valueg = item.gui
            this.effect = item.effect.split(',')
            this.flys = item.fly.split(',')
            this.times = []
            item.time.forEach(val=>{
              this.times.push({'time':val.time,'bai':val.bai})
            })
            this.zuTime()

          }

        })
      }

    },
    ct(id,time,bai){
      this.ct_id = id
      this.ct_time = time+'#'+bai
      this.ctDialogVisible = true
    },
    doCt(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ct_id,
          time:this.ct_time
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/timesChange'
      })
      .then(res=>{
         this.ctDialogVisible = false
         this.ct_id = 0
         this.ct_time = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeTime(id){
      this.ec_id = id
      this.timeVisible = true
    },
    addTime(){
      this.times.push({'time':this.time1+'-'+this.time2,'bai':this.at})
      this.zuTime()
    },
    delTime(index){
      this.times.splice(index,1);
      this.zuTime()
    },
    zuTime(){
      let a = []
      this.times.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStr = a.join(',')
    },
    addTimec(){
      this.timesc.push({'time':this.timec1+'-'+this.timec2,'bai':this.atc})
      this.zuTimec()
    },
    delTimec(index){
      this.timesc.splice(index,1);
      this.zuTimec()
    },
    zuTimec(){
      let a = []
      this.timesc.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStrc = a.join(',')
    },
    doEc(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ec_id,
          type:2,
          time:this.timesadd
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDoec'
      })
      .then(res=>{
         this.timeVisible = false
         this.timeStrc = ''
         this.timesc = []
         this.ec_id = 0

         this.loadData()

      })
      .catch(err=>{

      });
    },
    delEc(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDelec'
      })
      .then(res=>{

         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementfxChange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    clearFiles(){
      this.$refs['my-upload'].clearFiles();
    },
    handleRemove(file, fileList) {

      this.imageList = []
      fileList.forEach((item)=>{
        this.imageList.push(item.response.data)
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageList.push(file.response.data)
    },
    delAll(id){
      this.type = 1
      this.delId = id
      this.dialogVisibled = true
    },
    dels(id){
      this.type = 2
      this.delId = id
      this.dialogVisibleds = true
    },
    del(id){
      this.type = 2
      this.delId = id
      this.dialogVisibled = true
    },
    doDells(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementfxDelss'
      })
      .then(res=>{
         this.dialogVisibleds = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementfxDel'
      })
      .then(res=>{
         this.dialogVisibled = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    add(){

      if(this.imageList.length == 0){
        this.$message({
        	type: 'error',
        	message: '请选择图片'
        });
        return false
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          num:this.num,
          fly:this.flys.join(','),
          effect:this.effect.join(','),
          img:JSON.stringify(this.imageList),
          time:this.timeStr,
          zu:this.valueff,
          su:this.su,
          timea:this.timej,
          valueg:this.valueg,
          bi:this.bi,
          sx:this.sx,
          tou:this.tou,
          tlc:this.tlc,
          bsc:this.bsc,
          zyc:this.zyc,
          fengx:this.fengx.join(','),
          tname:this.Tname,
          shuoming:this.shuoming
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementfxAdd'
      })
      .then(res=>{
         this.loadData()
         this.name = ''
         this.imageList = []
         this.timeStr = ''
         this.times = []
         this.clearFiles()
      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          t:this.pait,
          p:this.page,
          name:this.seachName,
          type:1,
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/elementfxListNew'
    	})
    	.then(res=>{
        this.seeimgVisiblec = false;
        this.tableData = res.data.list;
        this.count = res.data.count;
    		// this.tableData = res.data;

    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
</style>



// WEBPACK FOOTER //
// src/components/main/elementfx.vue